import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../contexts/authContext";
import { Head2Head } from "../models/head-2-head";
import HeadToHead from "../components/head-to-head";
import "./vote.css";
import { useNavigate } from "react-router-dom";
import { ALL_GENRES } from "../models/genre";

export default function Vote() {
  const authContext = useContext(AuthContext);
  const [H2Hs, setH2Hs] = useState<Head2Head[]>([]);
  const [currentH2H, setCurrentH2H] = useState<number>(0);
  const [selectedGenre, setSelectedGenre] = useState<number>(0);
  const navigate = useNavigate();

  async function fetchH2Hs(genreId: number) {
    if (authContext && authContext.authApiClient) {
      let url = "/headtohead";
      if (genreId != 0){
        url += "/genre/" + genreId;
      }
      const response =
        await authContext.authApiClient.get<Head2Head[]>(url);
      if (response.status === 200) {
        setH2Hs(prevH2Hs => {
          const filtered = response.data.filter((h2h) =>
            prevH2Hs.every((h) => h.id !== h2h.id)
          );
          return prevH2Hs.concat(filtered);
        });
      }
    }
  }

  async function submitVote(h2hId: string, winnerId: number) {
    if (authContext && authContext.authApiClient) {
      const response = await authContext.authApiClient.post("/headtohead/vote", {
        headToHeadId: h2hId,
        vote: winnerId,
      });
      if (response.status === 200) {
        if (currentH2H < H2Hs.length) {
          setCurrentH2H(currentH2H + 1);
        } else {
          console.log("reached end");
        }
        if (currentH2H > H2Hs.length - 5) {
          await fetchH2Hs(selectedGenre);
        }
      } else {
        console.error(response.data);
      }
    }
  }

  useEffect(() => {
    setH2Hs([]);
    setCurrentH2H(0);
    fetchH2Hs(selectedGenre);
  }, [selectedGenre]);

  return (
    <div className="flex flex-col max-w-7xl mx-auto mt-16 px-4">
      <div className="self-center mb-10 flex flex-col md:flex-row items-center uppercase">
        <span className="text-xl sm:text-4xl text-orange-300">Show me matchups between</span>
        <select onChange={(e) => setSelectedGenre(parseInt(e.target.value))} className="px-4 py-2 mx-1 sm:text-2xl rounded text-orange-300 w-full md:w-auto font-bold border border-solid border-orange-300 bg-purple-900 text-center uppercase">
          {ALL_GENRES.map(g => (<option key={g.id} value={g.id}>{g.name}</option>))}
        </select>
        <span className="text-xl sm:text-4xl text-orange-300">movies</span>
      </div>
      {H2Hs.length > 0 && currentH2H < H2Hs.length ? (
        <HeadToHead vote={submitVote} h2h={H2Hs[currentH2H]} />
      ) : null}
      {H2Hs.length === 0 ? (
        <div className="text-center flex flex-col">
          You have either already voted for all possible movie matchups, or you have not imported movies yet.
          <button className="btn-primary mt-4 px-8 py-3 self-center" onClick={() => navigate("/import")}>IMPORT MOVIES</button>
        </div>
    ) : null}
    </div>
  );
}
